/**
 * Tiroir de filtres (collection et recherche) : un clic sur le fond grisé ferme
 * le tiroir sans appliquer les filtres cochés, alors que le client s'attend au
 * même résultat que le bouton « Appliquer ».
 *
 * Le fond grisé est le part « overlay » du shadow DOM de <facets-drawer>
 * (voir snippets/shadow-dom-templates.liquid) et theme.js n'y branche que hide().
 * Le clic remonte jusqu'au document avec le tiroir pour cible, on y retrouve
 * l'overlay via composedPath() et on soumet le formulaire comme le bouton
 * Appliquer. <facets-form> ignore la soumission si aucun filtre n'a changé.
 */
(() => {
  document.addEventListener('click', (event) => {
    const drawer = event.target;
    if (drawer.localName !== 'facets-drawer') return;
    if (event.composedPath()[0]?.getAttribute?.('part') !== 'overlay') return;

    drawer.querySelector('facets-form form')?.requestSubmit();
  });
})();
